import { IIconProps } from "./icons.models";

/**
 * The few glyphs the dashboard draws itself, in one stroke language: 24×24,
 * `currentColor`, 1.75 weight. Decorative by default — anything they stand for
 * is written next to them, so they carry `aria-hidden`.
 */
const ICON_PROPS = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.75,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": true,
} as const;

export const KeyIcon = ({ className }: IIconProps) => (
  <svg {...ICON_PROPS} className={className}>
    <circle cx="8" cy="16" r="5" />
    <path d="m11.6 12.4 8.4-8.4" />
    <path d="m16 8 2.5 2.5 2.5-2.5-2.5-2.5" />
  </svg>
);

export const ShieldCheckIcon = ({ className }: IIconProps) => (
  <svg {...ICON_PROPS} className={className}>
    <path d="M12 21.5c4.4-1.4 7-4.9 7-9.4V5.9a.9.9 0 0 0-.6-.85l-6-2.1a1.2 1.2 0 0 0-.8 0l-6 2.1a.9.9 0 0 0-.6.85v6.2c0 4.5 2.6 8 7 9.4Z" />
    <path d="m9 12 2.2 2.2L15.2 10" />
  </svg>
);
